import { format } from "d3-format";
import React, { Component } from "react";
import PropTypes from "prop-types";

import displayValuesFor from "./displayValuesFor";
import GenericChartComponent from "../GenericChartComponent";
import ToolTipText from "./ToolTipText";
import ToolTipTSpanLabel from "./ToolTipTSpanLabel";
import { functor } from "../utils";

class StochasticMomentumTooltip extends Component {
  constructor(props) {
    super(props);
    this.renderSVG = this.renderSVG.bind(this);
  }

  renderSVG(moreProps) {
    const { onClick, fontFamily, fontSize, displayFormat, className } =
      this.props;
    const { yAccessor, options, appearance, labelFill } = this.props;
    const { displayValuesFor } = this.props;

    const {
      chartConfig: { width, height },
    } = moreProps;

    const currentItem = displayValuesFor(this.props, moreProps);
    const smiValue = currentItem && yAccessor(currentItem);

    const k =
      (smiValue && smiValue.k != null && displayFormat(smiValue.k)) || "n/a";
    const d =
      (smiValue && smiValue.d != null && displayFormat(smiValue.d)) || "n/a";

    const { origin: originProp } = this.props;
    const origin = functor(originProp);
    const [x, y] = origin(width, height);

    const kColor = appearance?.strokeK?.color || "#8884d8";
    const dColor = appearance?.strokeD?.color || "#FF0000";

    const dMaType = (options?.dMaType || "ema").toUpperCase();

    return (
      <g
        className={className}
        transform={`translate(${x}, ${y})`}
        onClick={onClick}
        data-evo-id="tooltip-stochastic-momentum"
      >
        <ToolTipText x={0} y={0} fontFamily={fontFamily} fontSize={fontSize}>
          <ToolTipTSpanLabel fill={labelFill}>SMI %K (</ToolTipTSpanLabel>
          <tspan fill={labelFill}>{options?.kPeriods || 10}</tspan>
          <ToolTipTSpanLabel fill={labelFill}>, </ToolTipTSpanLabel>
          <tspan fill={labelFill}>{options?.kSmoothPeriods || 3}</tspan>
          <ToolTipTSpanLabel fill={labelFill}>, </ToolTipTSpanLabel>
          <tspan fill={labelFill}>{options?.kDoubleSmoothPeriods || 3}</tspan>
          <ToolTipTSpanLabel fill={labelFill}>): </ToolTipTSpanLabel>
          <tspan fill={kColor}>{k}</tspan>
          <ToolTipTSpanLabel fill={labelFill}> %D (</ToolTipTSpanLabel>
          <tspan fill={labelFill}>{dMaType}</tspan>
          <ToolTipTSpanLabel fill={labelFill}>, </ToolTipTSpanLabel>
          <tspan fill={dColor}>{options?.dPeriods || 10}</tspan>
          <ToolTipTSpanLabel fill={labelFill}>): </ToolTipTSpanLabel>
          <tspan fill={dColor}>{d}</tspan>
        </ToolTipText>
      </g>
    );
  }

  render() {
    return (
      <GenericChartComponent
        clip={false}
        svgDraw={this.renderSVG}
        drawOn={["mousemove"]}
      />
    );
  }
}

StochasticMomentumTooltip.propTypes = {
  origin: PropTypes.oneOfType([PropTypes.array, PropTypes.func]).isRequired,
  className: PropTypes.string,
  fontFamily: PropTypes.string,
  fontSize: PropTypes.number,
  labelFill: PropTypes.string,
  yAccessor: PropTypes.func.isRequired,
  options: PropTypes.object,
  appearance: PropTypes.object,
  displayFormat: PropTypes.func.isRequired,
  displayValuesFor: PropTypes.func.isRequired,
  onClick: PropTypes.func,
};

StochasticMomentumTooltip.defaultProps = {
  origin: [0, 0],
  className: "react-stockcharts-tooltip",
  displayFormat: format(".2f"),
  displayValuesFor: displayValuesFor,
  labelFill: "#4a4a4a",
  fontFamily: "Helvetica Neue, Helvetica, Arial, sans-serif",
  fontSize: 12,
};

export default StochasticMomentumTooltip;
